import { render, staticRenderFns } from "./ProductDetailsDesktop.vue?vue&type=template&id=d92ea9a8&scoped=true"
import script from "./ProductDetailsDesktop.vue?vue&type=script&lang=js"
export * from "./ProductDetailsDesktop.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsDesktop.vue?vue&type=style&index=0&id=d92ea9a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92ea9a8",
  null
  
)

export default component.exports